import * as React from "react";
import { RadiosEditor } from "../../../../../../../../react-core/Html/RadiosEditor";
import { isNullOrEmpty } from "../../../../../../../../react-core/Utils/Arrays";
import { CurrencyCode } from "../../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { SourceType } from "../../../../../../../../Wrap/Constants/Enums/Domain/SourceType";
import { SubAccountType } from "../../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { MoneyOrPercentage } from "../../../../../../../../Wrap/Models/Models/Shared/MoneyOrPercentage";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../../Shared/Process/Process/ProcessComponent";
import { AdviserChargesContents } from "../../../../Common/AdviserCharges/Resource/Contents";
import { ChargesHelper } from "../../../../Common/Helpers/ChargesHelper";
import { SubAccountTypeHelper } from "../../../../Common/Helpers/SubAccountTypeHelper";

interface IChargesCopyOptionProps extends IProcessComponentProps {}

interface IChargesCopyOptionState {}

export class ChargesCopyOption extends ProcessComponent<IChargesCopyOptionProps, IChargesCopyOptionState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        super.componentDidMount();
        const { data, onChange } = this.props;
        if (isNullOrEmpty(data.GiaModel.ChargesExtraInfo?.CopyChargesFromOtherWizard)) {
            if (!data.GiaModel.ChargesExtraInfo) {
                data.GiaModel.ChargesExtraInfo = { CopyChargesFromOtherWizard: false };
            } else {
                data.GiaModel.ChargesExtraInfo.CopyChargesFromOtherWizard = false;
            }
        }
        onChange(data);
    }

    copyCharges(source: SubAccountType, v: boolean) {
        const { data, onChange } = this.props;
        data.GiaModel.ChargesExtraInfo.CopyChargesFromOtherWizard = v;
        if (v) {
            if (SubAccountTypeHelper.isOnPlatformPension(source)) {
                if (ChargesHelper.displayIAC(data.GiaModel, SubAccountType.PersonalPortfolio)) {
                    const iac = {...data.PensionApply.InitialAdviserCharge};
                    iac.SourceType = SourceType.WrapCash;
                    data.GiaModel.InitialAdviserCharge = iac;
                }
                const oac = {...data.PensionApply.OngoingAdviceCharge};
                oac.SourceType = SourceType.WrapCash;
                data.GiaModel.OngoingAdviceCharge = oac;
            } else if (source === SubAccountType.StocksIsa) {
                if (ChargesHelper.displayIAC(data.GiaModel, SubAccountType.PersonalPortfolio)) {
                    data.GiaModel.InitialAdviserCharge = data.IsaModel.InitialAdviserCharge;
                }
                data.GiaModel.OngoingAdviceCharge = data.IsaModel.OngoingAdviceCharge;
            }
        } else {
            data.GiaModel.InitialAdviserCharge = this.emptyPercentageOrMoney();
            data.GiaModel.OngoingAdviceCharge = this.emptyPercentageOrMoney();
        }
        onChange(data);
    }

    emptyPercentageOrMoney(): MoneyOrPercentage {
        return {
            Type: null,
            Money: { Amount: null, Currency: CurrencyCode.GBP },
            Percentage: null,
            Frequency: null,
            SourceType: null,
        };
    }

    getSourceToCopy(): SubAccountType {
        const { data } = this.props;
        const sippProvided = ChargesHelper.chargesProvided(data.PensionApply);
        const isaProvided = ChargesHelper.chargesProvided(data.IsaModel);
        return sippProvided ? SubAccountType.Npr : isaProvided ? SubAccountType.StocksIsa : null;
    }

    public render(): JSX.Element {
        const source = this.getSourceToCopy();
        if (!source) {
            return null;
        }
        const label = SubAccountTypeHelper.isOnPlatformPension(source)
            ? AdviserChargesContents.CopyFromabrdnSipp
            : AdviserChargesContents.CopyFromIsa;
        return (
            <>
                <RadiosEditor
                    cssWrapper="rg-150 mb-24"
                    label={label}
                    options={[true, false]}
                    getText={(v) => (v ? "Yes" : "No")}
                    selected={this.props.data?.GiaModel?.ChargesExtraInfo?.CopyChargesFromOtherWizard}
                    onChange={(v) => this.copyCharges(source, v)}
                />
            </>
        );
    }
}
